// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-container {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.settings-container h1 {
  color: #f1f5f9;
  margin-bottom: 2rem;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.setting-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.5rem;
}

.setting-card h3 {
  color: #f1f5f9;
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-size: 1.2rem;
}

.setting-card p {
  color: #94a3b8;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.input-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.input-prefix,
.input-suffix {
  color: #cbd5e1;
  font-weight: 500;
}

.input-group input {
  flex: 1 1;
  padding: 0.75rem;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 1.1rem;
  font-weight: 600;
  transition: all 0.2s;
}

.input-group input:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

.setting-select {
  width: 100%;
  padding: 0.75rem;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 0.5rem;
}

.setting-select:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

.setting-select option {
  background: #1e293b;
}

.setting-info {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #334155;
}

.info-row {
  display: flex;
  justify-content: space-between;
  color: #94a3b8;
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
}

.info-row .recommended {
  color: #10b981;
  font-weight: 600;
}

.settings-footer {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
}

.save-btn {
  padding: 0.875rem 2rem;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.save-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(245, 158, 11, 0.3);
}

.save-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.message {
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
}

.message.success {
  background: rgba(16, 185, 129, 0.1);
  border: 1px solid #10b981;
  color: #10b981;
}

.message.error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  color: #ef4444;
}

.settings-help {
  margin-top: 3rem;
  padding: 2rem;
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
}

.settings-help h3 {
  color: #f1f5f9;
  margin-top: 0;
  margin-bottom: 1.5rem;
}

.help-section {
  margin-bottom: 1.5rem;
}

.help-section h4 {
  color: #f59e0b;
  margin-bottom: 0.5rem;
}

.help-section p {
  color: #cbd5e1;
  line-height: 1.6;
  margin: 0;
}

.loading {
  text-align: center;
  padding: 3rem;
  color: #94a3b8;
  font-size: 1.2rem;
}

/* ── Section titles ───────────────────────────────────────── */

.settings-section-title {
  color: #94a3b8;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin: 2rem 0 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #334155;
}

/* ── Toggle switch ────────────────────────────────────────── */

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-top: 0.5rem;
}

.toggle-label {
  color: #cbd5e1;
  font-size: 0.9rem;
}

.toggle-switch {
  width: 44px;
  height: 24px;
  background: #334155;
  border-radius: 9999px;
  position: relative;
  transition: background 0.2s;
  flex-shrink: 0;
}

.toggle-switch.on {
  background: #10b981;
}

.toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch.on .toggle-thumb {
  transform: translateX(20px);
}

/* ── Admin panel ──────────────────────────────────────────── */

.admin-panel {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.admin-token-row {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.admin-token-row label {
  color: #94a3b8;
  font-size: 0.875rem;
  white-space: nowrap;
}

.admin-token-input {
  flex: 1 1;
  max-width: 320px;
  padding: 0.5rem 0.75rem;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 6px;
  color: #f1f5f9;
  font-size: 0.9rem;
}

.admin-token-input:focus {
  outline: none;
  border-color: #f59e0b;
}

.admin-actions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
}

.admin-action-group {
  background: #0f172a;
  border-radius: 8px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.admin-action-group h4 {
  margin: 0;
  color: #f1f5f9;
  font-size: 1rem;
}

.admin-action-group p {
  margin: 0;
  color: #94a3b8;
  font-size: 0.8rem;
  line-height: 1.5;
}

.admin-action-group code {
  background: #1e293b;
  padding: 0.1em 0.3em;
  border-radius: 3px;
  font-size: 0.8em;
}

.upload-row {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.file-input {
  flex: 1 1;
  font-size: 0.8rem;
  color: #94a3b8;
}

.upload-filename {
  margin: 0;
  font-size: 0.8rem;
  color: #64748b;
}

.btn-secondary {
  padding: 0.5rem 1rem;
  background: #334155;
  color: #f1f5f9;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-secondary:hover:not(:disabled) {
  background: #475569;
}

.btn-secondary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.btn-danger {
  padding: 0.5rem 1rem;
  background: #7f1d1d;
  color: #fecaca;
  border: 1px solid #ef4444;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-danger:hover:not(:disabled) {
  background: #991b1b;
}

.btn-danger:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/Settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,gEAAgE;;AAEhE;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,gEAAgE;;AAEhE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gEAAgE;;AAEhE;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".settings-container {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.settings-container h1 {\n  color: #f1f5f9;\n  margin-bottom: 2rem;\n}\n\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.setting-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.5rem;\n}\n\n.setting-card h3 {\n  color: #f1f5f9;\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.2rem;\n}\n\n.setting-card p {\n  color: #94a3b8;\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.input-group {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.input-prefix,\n.input-suffix {\n  color: #cbd5e1;\n  font-weight: 500;\n}\n\n.input-group input {\n  flex: 1;\n  padding: 0.75rem;\n  background: #0f172a;\n  border: 1px solid #475569;\n  border-radius: 6px;\n  color: #f1f5f9;\n  font-size: 1.1rem;\n  font-weight: 600;\n  transition: all 0.2s;\n}\n\n.input-group input:focus {\n  outline: none;\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);\n}\n\n.setting-select {\n  width: 100%;\n  padding: 0.75rem;\n  background: #0f172a;\n  border: 1px solid #475569;\n  border-radius: 6px;\n  color: #f1f5f9;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 0.5rem;\n}\n\n.setting-select:focus {\n  outline: none;\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);\n}\n\n.setting-select option {\n  background: #1e293b;\n}\n\n.setting-info {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #334155;\n}\n\n.info-row {\n  display: flex;\n  justify-content: space-between;\n  color: #94a3b8;\n  font-size: 0.8rem;\n  margin-bottom: 0.5rem;\n}\n\n.info-row .recommended {\n  color: #10b981;\n  font-weight: 600;\n}\n\n.settings-footer {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.save-btn {\n  padding: 0.875rem 2rem;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.save-btn:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(245, 158, 11, 0.3);\n}\n\n.save-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.message {\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 500;\n}\n\n.message.success {\n  background: rgba(16, 185, 129, 0.1);\n  border: 1px solid #10b981;\n  color: #10b981;\n}\n\n.message.error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid #ef4444;\n  color: #ef4444;\n}\n\n.settings-help {\n  margin-top: 3rem;\n  padding: 2rem;\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n}\n\n.settings-help h3 {\n  color: #f1f5f9;\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n}\n\n.help-section {\n  margin-bottom: 1.5rem;\n}\n\n.help-section h4 {\n  color: #f59e0b;\n  margin-bottom: 0.5rem;\n}\n\n.help-section p {\n  color: #cbd5e1;\n  line-height: 1.6;\n  margin: 0;\n}\n\n.loading {\n  text-align: center;\n  padding: 3rem;\n  color: #94a3b8;\n  font-size: 1.2rem;\n}\n\n/* ── Section titles ───────────────────────────────────────── */\n\n.settings-section-title {\n  color: #94a3b8;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin: 2rem 0 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #334155;\n}\n\n/* ── Toggle switch ────────────────────────────────────────── */\n\n.toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  user-select: none;\n  margin-top: 0.5rem;\n}\n\n.toggle-label {\n  color: #cbd5e1;\n  font-size: 0.9rem;\n}\n\n.toggle-switch {\n  width: 44px;\n  height: 24px;\n  background: #334155;\n  border-radius: 9999px;\n  position: relative;\n  transition: background 0.2s;\n  flex-shrink: 0;\n}\n\n.toggle-switch.on {\n  background: #10b981;\n}\n\n.toggle-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 18px;\n  height: 18px;\n  background: white;\n  border-radius: 50%;\n  transition: transform 0.2s;\n}\n\n.toggle-switch.on .toggle-thumb {\n  transform: translateX(20px);\n}\n\n/* ── Admin panel ──────────────────────────────────────────── */\n\n.admin-panel {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.admin-token-row {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.admin-token-row label {\n  color: #94a3b8;\n  font-size: 0.875rem;\n  white-space: nowrap;\n}\n\n.admin-token-input {\n  flex: 1;\n  max-width: 320px;\n  padding: 0.5rem 0.75rem;\n  background: #0f172a;\n  border: 1px solid #475569;\n  border-radius: 6px;\n  color: #f1f5f9;\n  font-size: 0.9rem;\n}\n\n.admin-token-input:focus {\n  outline: none;\n  border-color: #f59e0b;\n}\n\n.admin-actions {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 1.5rem;\n}\n\n.admin-action-group {\n  background: #0f172a;\n  border-radius: 8px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.admin-action-group h4 {\n  margin: 0;\n  color: #f1f5f9;\n  font-size: 1rem;\n}\n\n.admin-action-group p {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 0.8rem;\n  line-height: 1.5;\n}\n\n.admin-action-group code {\n  background: #1e293b;\n  padding: 0.1em 0.3em;\n  border-radius: 3px;\n  font-size: 0.8em;\n}\n\n.upload-row {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.file-input {\n  flex: 1;\n  font-size: 0.8rem;\n  color: #94a3b8;\n}\n\n.upload-filename {\n  margin: 0;\n  font-size: 0.8rem;\n  color: #64748b;\n}\n\n.btn-secondary {\n  padding: 0.5rem 1rem;\n  background: #334155;\n  color: #f1f5f9;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: #475569;\n}\n\n.btn-secondary:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.btn-danger {\n  padding: 0.5rem 1rem;\n  background: #7f1d1d;\n  color: #fecaca;\n  border: 1px solid #ef4444;\n  border-radius: 6px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s;\n  white-space: nowrap;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #991b1b;\n}\n\n.btn-danger:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
